// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-circle {
  display: inline-block;
  position: relative;
  --spinner-color: var(--ion-color-primary-rgb);
}
.spinner-circle--accent {
  --spinner-color: var(--ion-color-accent-rgb);
}
.spinner-circle--success {
  --spinner-color: var(--ion-color-success-rgb);
}
.spinner-circle--warning {
  --spinner-color: var(--ion-color-warning-rgb);
}
.spinner-circle--danger {
  --spinner-color: var(--ion-color-danger-rgb);
}
.spinner-circle--light {
  --spinner-color: var(--ion-color-light-rgb);
}
.spinner-circle ion-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  animation: intermittentLoad 1.1s infinite linear;
  color: rgba(var(--spinner-color), 1);
}
.spinner-circle .loader,
.spinner-circle .loader:after {
  border-radius: 50%;
  width: 100px;
  height: 100px;
}
.spinner-circle .loader {
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 6px solid rgba(var(--spinner-color), 0.2);
  border-right: 6px solid rgba(var(--spinner-color), 0.2);
  border-bottom: 6px solid rgba(var(--spinner-color), 0.2);
  border-left: 6px solid rgba(var(--spinner-color), 1);
  transform: translateZ(0);
  animation: rotateLoad 1.1s infinite linear;
}
.spinner-circle--static .loader {
  border-left: 6px solid rgba(var(--spinner-color), 0.2);
  animation: none;
}
.spinner-circle--static ion-icon {
  animation: none;
}
@keyframes rotateLoad {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes intermittentLoad {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/core/modules/shared/components/spinner-circle/spinner-circle.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,kBAAA;EACA,6CAAA;AACF;AACE;EACE,4CAAA;AACJ;AAEE;EACE,6CAAA;AAAJ;AAGE;EACE,6CAAA;AADJ;AAIE;EACE,4CAAA;AAFJ;AAKE;EACE,2CAAA;AAHJ;AAME;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EAEA,gDAAA;EACA,oCAAA;AAJJ;AAOE;;EAEE,kBAAA;EACA,YAAA;EACA,aAAA;AALJ;AAQE;EACE,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,qDAAA;EACA,uDAAA;EACA,wDAAA;EACA,oDAAA;EAGA,wBAAA;EAEA,0CAAA;AANJ;AAUI;EACE,sDAAA;EAEA,eAAA;AARN;AAWI;EAEE,eAAA;AATN;AAyBA;EACE;IAEE,uBAAA;EAZF;EAcA;IAEE,yBAAA;EAZF;AACF;AA2BA;EACE;IACE,UAAA;EAdF;EAgBA;IACE,YAAA;EAdF;EAgBA;IACE,UAAA;EAdF;AACF","sourcesContent":[".spinner-circle {\n  display: inline-block;\n  position: relative;\n  --spinner-color: var(--ion-color-primary-rgb);\n\n  &--accent {\n    --spinner-color: var(--ion-color-accent-rgb);\n  }\n\n  &--success {\n    --spinner-color: var(--ion-color-success-rgb);\n  }\n\n  &--warning {\n    --spinner-color: var(--ion-color-warning-rgb);\n  }\n\n  &--danger {\n    --spinner-color: var(--ion-color-danger-rgb);\n  }\n\n  &--light {\n    --spinner-color: var(--ion-color-light-rgb);\n  }\n\n  ion-icon {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    -webkit-animation: intermittentLoad 1.1s infinite linear;\n    animation: intermittentLoad 1.1s infinite linear;\n    color: rgba(var(--spinner-color), 1);\n  }\n\n  .loader,\n  .loader:after {\n    border-radius: 50%;\n    width: 100px;\n    height: 100px;\n  }\n\n  .loader {\n    font-size: 10px;\n    position: relative;\n    text-indent: -9999em;\n    border-top: 6px solid rgba(var(--spinner-color), 0.2);\n    border-right: 6px solid rgba(var(--spinner-color), 0.2);\n    border-bottom: 6px solid rgba(var(--spinner-color), 0.2);\n    border-left: 6px solid rgba(var(--spinner-color), 1);\n    -webkit-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-animation: rotateLoad 1.1s infinite linear;\n    animation: rotateLoad 1.1s infinite linear;\n  }\n\n  &--static {\n    .loader {\n      border-left: 6px solid rgba(var(--spinner-color), 0.2);\n      -webkit-animation: none;\n      animation: none;\n    }\n\n    ion-icon {\n      -webkit-animation: none;\n      animation: none;\n    }\n  }\n}\n\n@-webkit-keyframes rotateLoad {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes rotateLoad {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@-webkit-keyframes intermittentLoad {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.1;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes intermittentLoad {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.1;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
